import React from 'react';
import { useRBAC } from '../contexts/RBACContext';
import { Lock } from 'lucide-react';
interface PermissionGateProps {
  module: string;
  action: 'view' | 'edit' | 'create' | 'delete';
  field?: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  showLock?: boolean; // If true, shows a lock icon/tooltip instead of hiding
}
export function PermissionGate({
  module,
  action,
  field,
  children,
  fallback = null,
  showLock = false
}: PermissionGateProps) {
  const {
    canView,
    canEdit,
    canCreate,
    canDelete
  } = useRBAC();
  let hasPermission = false;
  switch (action) {
    case 'view':
      hasPermission = canView(module, field);
      break;
    case 'edit':
      hasPermission = canEdit(module, field);
      break;
    case 'create':
      hasPermission = canCreate(module);
      break;
    case 'delete':
      hasPermission = canDelete(module);
      break;
  }
  if (hasPermission) {
    return <>{children}</>;
  }
  if (showLock) {
    return <div className="relative group cursor-not-allowed opacity-60" data-id="element-304">
        <div className="pointer-events-none" data-id="element-305">{children}</div>
        <div className="absolute inset-0 flex items-center justify-center bg-slate-100/50 backdrop-blur-[1px] rounded-lg opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-306">
          <div className="bg-slate-800 text-white text-xs px-2 py-1 rounded flex items-center gap-1 shadow-lg" data-id="element-307">
            <Lock className="h-3 w-3" data-id="element-308" />
            Permesso negato
          </div>
        </div>
      </div>;
  }
  return <>{fallback}</>;
}